const Divider = () => {
  return <div className="w-full h-px bg-slate-300 my-2"></div>;
};

export default Divider;
